import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AccordionSection from './accordionSection';
import { useDebounce } from '@brandfolder/react';

export const SkuFilter = ({ updateFilters }) => {
  const [searchInput, setSearchInput] = useState(undefined);
  const searchInputDebounced = useDebounce(searchInput, 500);

  const updateSkus = (value) => {
    /* eslint-disable no-useless-escape */
    const str = `(\"${value.trim().replace(/['"]+/g, '').split(/[\s,;\t\n]+/).join('\" OR \"')}\")`;
    setSearchInput(str);
  }

  useEffect(() => {
    // Parent functions don't handle empty strings well
    if (searchInputDebounced === undefined) { return; }

    updateFilters(searchInputDebounced);
  }, [searchInputDebounced]);

  return (
    <AccordionSection title={bfTranslate("SKU Search")}>
      <React.Fragment>
        <div className="flex-row">
          <div className="filter-search-row sku">
            <span>{bfTranslate("Terms")}:</span>
            <div className="sku-search-container">
              <span className="bff-search" />
              <textarea
                rows={3}
                onChange={(e) => { updateSkus(e.target.value) }}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    </AccordionSection>
  );
}

SkuFilter.propTypes = {
  updateFilters: PropTypes.func.isRequired,
};

export default SkuFilter;